/**
 * Created by Administrator on 2018/6/4.
 */
import vConsole from 'vconsole'
/* eslint-disable */
const mode = process.env.VUE_APP_MODE
let VConsole
if (process.env.NODE_ENV === 'development' || mode === 'testtx') {
  VConsole = new vConsole()
}

export default VConsole



// WEBPACK FOOTER //
// ./src/config.js